import React, { Component, Fragment, useState, useEffect } from "react";
import { Input, Container, Row, Col } from "reactstrap";
import { NavLink } from "react-router-dom";
import { Link } from 'react-router-dom';

import darktheme from '../assets/images/ftr-darktheam.png';
import sms from '../assets/images/sms.svg';
import { useTranslation, I18nextProvider } from "react-i18next";
import { useNavigate } from "react-router";
import { useCustomizeContext } from "../context";
import { useSelector } from "react-redux";


import {
  Collapse,
  Nav,
  NavItem,
  Modal,
  Navbar,
  Dropdown,
  NavbarToggler, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, ModalBody
} from "reactstrap";

import brazilFlag from "../../src/assets/images/brazil.png";
import usFlag from "../../src/assets/images/united-states-of-america.png";


const Footer = (props) => {
  const { t, i18n } = useTranslation();

  const footercontent = useSelector((state) => state?.siteSettings?.getSiteRes)

  const {

    loader: {
      loading, setLoading,
    },
    siteInformation: {
      copyrightstext,
      copyrightstextPt,
      email,
      facebook,
      twitter,
      github,
      discord,
      logo,
    },
    languageContext: {
      language, setLanguage,
      changeLanguageRes, setChangeLanguageRes,
      languageType, setLanguageType,
    }
  } = useCustomizeContext();

  useEffect(() => {
    setLanguageType(localStorage.getItem("lang"))
  }, [changeLanguageRes]);


  const languageLists = [

    {
      name: "Portuguese BR",
      icon: "🇧🇷",
      url: brazilFlag,
      value: "pt"
    },
    {
      name: "English",
      icon: "🇺🇸",
      url: usFlag,
      value: "en"
    },
  ]



  const [dropdownOpen, setdropdownOpen] = useState(false);
  const [langDrop, setlangDrop] = useState("🇺🇸");
  const [flagUrl, setFlagUrl] = useState("");
  const toggleDrop = () => setdropdownOpen(!dropdownOpen);



  useEffect(() => {
    let lang = localStorage.getItem("lang");
    if (lang == "en") {
      setLanguage(languageLists[1]);
      setlangDrop(languageLists[1]?.icon);
      setFlagUrl(languageLists[1]?.url);
      localStorage.setItem("lang", languageLists[1]?.value);
      setLanguageType(languageLists[1]?.value);
      i18n.changeLanguage(languageLists[1]?.value);
      localStorage.setItem("i18nextLng", languageLists[1]?.value)
    }
    else {
      setLanguage(languageLists[0]);
      setlangDrop(languageLists[0]?.icon);
      setFlagUrl(languageLists[0]?.url);
      localStorage.setItem("lang", languageLists[0]?.value);
      setLanguageType(languageLists[0]?.value);
      i18n.changeLanguage(languageLists[0]?.value);
      localStorage.setItem("i18nextLng", languageLists[0]?.value)
    }
  }, []);


  const selectLanguage = (data) => {
    setlangDrop(data.icon);
    setFlagUrl(data?.url);
    setLanguage(data);
    i18n.changeLanguage(data?.value);
    localStorage.setItem("lang", data?.value);
    setLanguageType(data?.value);
    setChangeLanguageRes(!changeLanguageRes);
  }


  useEffect(() => {
    const lang = localStorage.getItem("lang");
    if (lang) {
      localStorage.setItem("lang",lang);
    }
    function storageEventHandler(event) {
       if (event.key === "lang") {
        i18n.changeLanguage(event.newValue);
      }
    }
    window.addEventListener("storage", storageEventHandler);
    return () => {
       window.removeEventListener("storage", storageEventHandler);
    };
 }, []);


  return (
    <Fragment>
      <footer>
        <div class="ftr-maincnt">
          <div class="row">
            <div class="col-12 col-lg-3 text-center">
              <div class="ftr-logo text-lg-left">
                <img src={darktheme} alt="" class="img-fluid" />
              </div>
              <p class="ftr-txt text-lg-left">{language?.value == "en" ? footercontent?.data?.footercontent : footercontent?.data?.footerContentPt}</p>

              {/*   Language Section */}

              <div className='lang_Drop my-3'>
                <Dropdown isOpen={dropdownOpen} toggle={toggleDrop}>
                  <DropdownToggle>
                    <img style={{ height: "20px", width: "20px" }} src={flagUrl} alt="No Flag" />
                  </DropdownToggle>
                  <DropdownMenu>
                    {languageLists?.map((temp, index) =>
                      <DropdownItem onClick={() => selectLanguage(temp)}><span><img src={temp?.url} style={{ height: "20px", width: "20px" }} /></span> {temp?.name}</DropdownItem>
                    )}
                  </DropdownMenu>
                </Dropdown>
              </div>

            </div>
            <div class="col-12 col-lg-9 mt-4 mt-lg-0">
              <div class="ftr-menucnt">
                <div class="row">
                  <div class="col-sm-3 col-md-4">
                    <div class="ftr-inrcnt">
                      <h5>{t("Games")}</h5>
                      <ul class="ftr-menu">
                        <li><Link to="/crash">{t("Crash")}</Link></li>
                        <li><Link to="/mines">{t("Mines")}</Link></li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-sm-4 col-md-4 my-4 my-sm-0">
                    <div class="ftr-inrcnt">
                      <h5>{t("About Us")}</h5>
                      <ul class="ftr-menu">
                        <li><Link to="/terms">{t("Terms of Services")}</Link></li>
                        <li><Link to="/privacy">{t("Privacy Policy")}</Link></li>
                        <li><Link to="/about">{t("About Rico Jogos")}</Link></li>
                        <li><Link to="/faq">{t("FAQ")}</Link></li>
                        <li><Link to="/contactus">{t("Help Center")}</Link></li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-sm-5 col-md-4">
                    <div class="ftr-inrcnt">
                      <h5>{t("Join our Community")}</h5>

                      <ul className="ftr-social">
                        <li>
                          <a href={facebook} target="_blank">
                            <div className="ftr-socialbox fb-box">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_441_3715)">
                                  <path d="M7.2381 10.0954V13.9049H10.0952V20.5716H13.9048V13.9049H16.7619L17.7143 10.0954H13.9048V8.19062C13.9048 7.93803 14.0051 7.69579 14.1837 7.51718C14.3623 7.33857 14.6046 7.23823 14.8571 7.23823H17.7143V3.42871H14.8571C13.5942 3.42871 12.383 3.93041 11.49 4.82344C10.5969 5.71647 10.0952 6.92768 10.0952 8.19062V10.0954H7.2381Z" fill="#46A6FF" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_441_3715">
                                    <rect width="22.8571" height="22.8571" fill="white" transform="translate(0.571411 0.571533)" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                          </a>
                        </li>
                        <li>
                          <a href={twitter} target="_blank">
                            <div className="ftr-socialbox twiter-box">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_441_3720)">
                                  <path d="M21.5238 4.39049C20.5714 4.85716 19.6381 5.04668 18.6667 5.33335C17.5991 4.12858 16.0162 4.06192 14.4952 4.63144C12.9743 5.20097 11.9781 6.59335 12 8.19049V9.14287C8.90953 9.22192 6.15715 7.8143 4.38096 5.33335C4.38096 5.33335 0.398101 12.4124 8.19048 15.8095C6.40762 16.9972 4.62953 17.7981 2.4762 17.7143C5.62667 19.4314 9.06001 20.0219 12.0324 19.1591C15.4419 18.1686 18.2438 15.6133 19.3191 11.7857C19.6398 10.6216 19.7991 9.41893 19.7924 8.21144C19.7905 7.9743 21.2305 5.57144 21.5238 4.38954V4.39049Z" fill="#41C3FF" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_441_3720">
                                    <rect width="22.8571" height="22.8571" fill="white" transform="translate(0.571411 0.571533)" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                          </a>
                        </li>
                        <li>
                          <a href={github} target="_blank">
                            <div className="ftr-socialbox github-box">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_441_3726)">
                                  <path d="M9.14281 18.6668C5.04758 20.0001 5.04758 16.2858 3.42853 15.8097L9.14281 18.6668ZM14.8571 20.5716V17.2382C14.8571 16.2858 14.9523 15.9049 14.3809 15.3335C17.0476 15.0477 19.619 14.0001 19.619 9.61918C19.6178 8.48105 19.1738 7.38804 18.3809 6.57156C18.7528 5.58295 18.7185 4.48739 18.2857 3.52394C18.2857 3.52394 17.2381 3.23822 14.9523 4.76203C13.0164 4.25783 10.9835 4.25783 9.04757 4.76203C6.76186 3.23822 5.71424 3.52394 5.71424 3.52394C5.28137 4.48739 5.24713 5.58295 5.619 6.57156C4.8261 7.38804 4.38207 8.48105 4.38091 9.61918C4.38091 14.0001 6.95234 15.0477 9.619 15.3335C9.04757 15.9049 9.04757 16.4763 9.14281 17.2382V20.5716" fill="#FF687A" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_441_3726">
                                    <rect width="22.8571" height="22.8571" fill="white" transform="translate(0.571411 0.571533)" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                          </a>
                        </li>
                        <li>
                          <a href={discord} target="_blank">
                            <div className="ftr-socialbox sb-box">
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_441_3731)">
                                  <path d="M9.14281 12.9524C9.6688 12.9524 10.0952 12.526 10.0952 12C10.0952 11.474 9.6688 11.0476 9.14281 11.0476C8.61683 11.0476 8.19043 11.474 8.19043 12C8.19043 12.526 8.61683 12.9524 9.14281 12.9524Z" stroke="#6F18FA" stroke-opacity="0.996" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M14.8571 12.9524C15.3831 12.9524 15.8095 12.526 15.8095 12C15.8095 11.474 15.3831 11.0476 14.8571 11.0476C14.3311 11.0476 13.9047 11.474 13.9047 12C13.9047 12.526 14.3311 12.9524 14.8571 12.9524Z" stroke="#6F18FA" stroke-opacity="0.996" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M7.71429 7.71429C11.0476 6.7619 12.9524 6.7619 16.2857 7.71429" stroke="#6F18FA" stroke-opacity="0.996" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M7.2381 16.2859C10.5714 17.2383 13.4286 17.2383 16.7619 16.2859" stroke="#6F18FA" stroke-opacity="0.996" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M15.3333 16.7621C15.3333 17.7144 16.7619 19.6192 17.2381 19.6192C18.6666 19.6192 19.9362 18.0316 20.5714 16.7621C21.2066 15.1744 21.0476 11.2068 19.1428 5.80968C17.7552 4.84301 16.2857 4.53348 14.8571 4.3811L13.9047 6.76206" stroke="#6F18FA" stroke-opacity="0.996" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M8.66667 16.7621C8.66667 17.7144 7.37524 19.6192 6.92191 19.6192C5.56095 19.6192 4.35238 18.0316 3.74762 16.7621C3.14286 15.1744 3.29429 11.2068 5.10762 5.80968C6.42953 4.84301 7.75714 4.53348 9.14286 4.3811L10.0952 6.76206" stroke="#6F18FA" stroke-opacity="0.996" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_441_3731">
                                    <rect width="22.8571" height="22.8571" fill="white" transform="translate(0.571411 0.571533)" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                          </a>
                        </li>
                        <li>
                          <a href={discord} target="_blank">
                            <div className="ftr-socialbox ins-box">

                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <mask id="mask0_442_14866" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                  <path d="M24 0H0V24H24V0Z" fill="white" />
                                </mask>
                                <g mask="url(#mask0_442_14866)">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M4 8C4 6.9391 4.4214 5.9217 5.1716 5.1716C5.9217 4.4214 6.9391 4 8 4H16C17.0609 4 18.0783 4.4214 18.8284 5.1716C19.5786 5.9217 20 6.9391 20 8V16C20 17.0609 19.5786 18.0783 18.8284 18.8284C18.0783 19.5786 17.0609 20 16 20H8C6.9391 20 5.9217 19.5786 5.1716 18.8284C4.4214 18.0783 4 17.0609 4 16V8ZM9.3483 9.3483C10.0516 8.6451 11.0054 8.25 12 8.25C12.9946 8.25 13.9484 8.6451 14.6517 9.3483C15.3549 10.0516 15.75 11.0054 15.75 12C15.75 12.9946 15.3549 13.9484 14.6517 14.6517C13.9484 15.3549 12.9946 15.75 12 15.75C11.0054 15.75 10.0516 15.3549 9.3483 14.6517C8.6451 13.9484 8.25 12.9946 8.25 12C8.25 11.0054 8.6451 10.0516 9.3483 9.3483ZM12 9.75C11.4033 9.75 10.831 9.9871 10.409 10.409C9.9871 10.831 9.75 11.4033 9.75 12C9.75 12.5967 9.9871 13.169 10.409 13.591C10.831 14.0129 11.4033 14.25 12 14.25C12.5967 14.25 13.169 14.0129 13.591 13.591C14.0129 13.169 14.25 12.5967 14.25 12C14.25 11.4033 14.0129 10.831 13.591 10.409C13.169 9.9871 12.5967 9.75 12 9.75ZM17.25 7.5C17.25 7.0858 16.9142 6.75 16.5 6.75C16.0858 6.75 15.75 7.0858 15.75 7.5V7.51C15.75 7.9242 16.0858 8.26 16.5 8.26C16.9142 8.26 17.25 7.9242 17.25 7.51V7.5Z" fill="#ED80FF" />
                                </g>
                              </svg>

                            </div>
                          </a>
                        </li>
                        <li>
                          <a href={discord} target="_blank">
                            <div className="ftr-socialbox tktk-box">

                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <mask id="mask0_442_14873" style={{maskType:"luminance"}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                  <path d="M24 0H0V24H24V0Z" fill="white" />
                                </mask>
                                <g mask="url(#mask0_442_14873)">
                                  <path d="M16.0831 2H12.0001C11.7348 2 11.4805 2.1054 11.293 2.2929C11.1054 2.4804 11.0001 2.7348 11.0001 3V14.5C11.0002 14.7492 10.9382 14.9944 10.8198 15.2136C10.7014 15.4328 10.5303 15.6191 10.3218 15.7556C10.1134 15.8921 9.87421 15.9745 9.62601 15.9955C9.37771 16.0164 9.12811 15.9751 8.89981 15.8754C8.67141 15.7757 8.47151 15.6207 8.31811 15.4243C8.16471 15.228 8.06261 14.9966 8.02111 14.7509C7.97951 14.5053 7.99981 14.2531 8.08011 14.0173C8.16041 13.7814 8.29821 13.5693 8.48111 13.4L8.60111 13.3C8.72511 13.2067 8.82571 13.0859 8.89491 12.9471C8.96421 12.8082 9.00021 12.6552 9.00011 12.5V8.174C9.00021 8.0231 8.96611 7.874 8.90051 7.7381C8.83481 7.6022 8.73921 7.4829 8.62091 7.3892C8.50251 7.2955 8.36451 7.2298 8.21721 7.197C8.06981 7.1643 7.91701 7.1653 7.77011 7.2C5.97911 7.6221 4.40591 8.6878 3.34951 10.1943C2.29321 11.7009 1.8276 13.5432 2.04121 15.3708C2.25481 17.1983 3.13281 18.8836 4.50811 20.1059C5.88341 21.3282 7.66011 22.0023 9.50011 22L9.74311 21.995C11.6889 21.9319 13.534 21.1147 14.8882 19.716C16.2425 18.3173 16.9998 16.4469 17.0001 14.5V11.8L17.3111 11.953C18.4331 12.483 19.6441 12.821 20.9011 12.946C21.0401 12.9598 21.1805 12.9444 21.3133 12.9006C21.446 12.8568 21.568 12.7857 21.6716 12.6919C21.7751 12.598 21.8579 12.4835 21.9144 12.3558C21.971 12.228 22.0002 12.0897 22.0001 11.95V7.917C22 7.6806 21.9162 7.4518 21.7636 7.2713C21.6109 7.0908 21.3992 6.9702 21.1661 6.931C20.1427 6.7574 19.1987 6.2699 18.4647 5.536C17.7307 4.8022 17.2429 3.8583 17.0691 2.835C17.03 2.6017 16.9095 2.3898 16.729 2.2369C16.5485 2.084 16.3196 2.0001 16.0831 2Z" fill="#46FFF4" />
                                </g>
                              </svg>


                            </div>
                          </a>
                        </li>
                      </ul>
                      <div class="mt-3">
                        <img src={sms} alt="" class="img-fluid" />
                      </div>
                      <div class="email-link">
                        <a href="#">{email ? email : `${t('loading')} ...`}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="copy-right">
            <p>{languageType === "pt" ? copyrightstextPt ? copyrightstextPt : `${t('loading')} ...` : copyrightstext ? copyrightstext : `${t('loading')} ...`}.</p>
          </div>
        </div>



      </footer>
    </Fragment>
  );

}



export default Footer;
